import * as z from 'zod';
import { FormTemplateFieldOutSchema, NewFormTemplateFieldSchema } from '../../types/formFields/formTemplates';
import { FieldType } from '../../types/formFields/common';
import i18n from '../../i18n/config';

export const DisplayNames = {
  text: i18n.t('forms.fieldTypes.text'),
  rich_text: i18n.t('forms.fieldTypes.richText'),
  date: i18n.t('forms.fieldTypes.date'),
  dropdown: i18n.t('forms.fieldTypes.dropdown'),
  boolean: i18n.t('forms.fieldTypes.boolean'),
  numeric: i18n.t('forms.fieldTypes.numeric'),
  attachment: i18n.t('forms.fieldTypes.attachment'),
  document: i18n.t('forms.fieldTypes.document'),
  event: i18n.t('forms.fieldTypes.event'),
  supplier: i18n.t('forms.fieldTypes.supplier'),
  user: i18n.t('forms.fieldTypes.user'),
  section: i18n.t('forms.fieldTypes.section'),
  checkbox: i18n.t('forms.fieldTypes.checkbox'),
  radio: i18n.t('forms.fieldTypes.radio'),
  change_request: i18n.t('forms.fieldTypes.changeRequest'),
  registry: i18n.t('forms.fieldTypes.registry'),
  design_controls: i18n.t('forms.fieldTypes.designControls'),
  training_plan: i18n.t('forms.fieldTypes.training'),
  document_template: i18n.t('forms.fieldTypes.documentTemplates'),
  event_template: i18n.t('forms.fieldTypes.eventTemplates'),
  task: i18n.t('forms.fieldTypes.task'),
} as const satisfies Record<FieldType, string>;

export const FormEditorFormSchema = z.object({
  fields: z
    .array(z.union([FormTemplateFieldOutSchema, NewFormTemplateFieldSchema]))
    .min(1, 'At least one field is required'),
});

export type FormEditorForm = z.infer<typeof FormEditorFormSchema>;

export type AddField = (field: FieldType, resourceSubType?: string) => void;
